<template>
    <Modal
        :is-open="showRedemptionEditModal"
        title="Edit redemption"
        @close="tripsStore.closeRedemptionEditModal()"
    >
        <template #content>
            <div class="mb-8">
                <RedemptionStep2 />
                <RedemptionStep3 />
            </div>
        </template>
        <template #errors>
            <div class="flex justify-center">
                <Errors :errors="errors" />
            </div>
        </template>
        <template #footer>
            <div class="flex justify-end items-center gap-4">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="tripsStore.closeRedemptionEditModal()"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="tripsStore.updateRedemption()"
                >
                    Save Changes
                </button>
            </div>
        </template>
    </Modal>
</template>
<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import Modal from '@/components/ui/modal/ui-modal.vue';
import Errors from '@/components/errors.vue';
import RedemptionStep2 from '@/components/trips/modals/steps/redemption-step-2.vue';
import RedemptionStep3 from '@/components/trips/modals/steps/redemption-step-3.vue';

const tripsStore = useTripsStore();
const { showRedemptionEditModal, errors } = storeToRefs(tripsStore);

onMounted(() => {
    tripsStore.setRedemptionStep(3);
});
</script>
